/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_SubmitInputs */

const vi_assign_driver_submit = /** @type {(inputs: Assign_Driver_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao cho tài xế`)
};

/**

* @param {Assign_Driver_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_submit = /** @type {((inputs?: Assign_Driver_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_submit(inputs)
});